import * as Types from '../../../generated/types';

import { gql } from 'apollo-angular';
import { Injectable } from '@angular/core';
import * as Apollo from 'apollo-angular';
export type CompanySupplierInvoiceListQueryVariables = Types.Exact<{
  last?: Types.InputMaybe<Types.Scalars['Int']>;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']>;
  sortColumn?: Types.InputMaybe<Types.Scalars['String']>;
  status?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['Int']>> | Types.InputMaybe<Types.Scalars['Int']>>;
  fakturaNr?: Types.InputMaybe<Types.Scalars['String']>;
  ocr?: Types.InputMaybe<Types.Scalars['String']>;
  contactTrueId?: Types.InputMaybe<Types.Scalars['String']>;
  contactOrderBuisnessName?: Types.InputMaybe<Types.Scalars['String']>;
  projectsTrueIds?: Types.InputMaybe<Types.Scalars['String']>;
  your_reference?: Types.InputMaybe<Types.Scalars['String']>;
  our_reference?: Types.InputMaybe<Types.Scalars['String']>;
  ovrigt?: Types.InputMaybe<Types.Scalars['String']>;
  your_order_nr?: Types.InputMaybe<Types.Scalars['String']>;
  fromFdatum?: Types.InputMaybe<Types.Scalars['String']>;
  toFdatum?: Types.InputMaybe<Types.Scalars['String']>;
  search?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type CompanySupplierInvoiceListQuery = { __typename?: 'HyperionSchemaQuery', company?: { __typename?: 'Company', id: string, supplierInvoices?: { __typename?: 'InvoiceConnection', totalCount: number, edges?: Array<{ __typename?: 'InvoiceEdge', node?: { __typename?: 'Invoice', id: string, fakturaNr?: string | null, type?: number | null, kreditfaktura?: number | null, invoiceReminder?: number | null, sumBox?: number | null, momsBox?: string | null, rotBox?: string | null, totalBox?: string | null, bruttoBox?: number | null, status?: number | null, rotYear?: number | null, projectInvoiceHistory?: number | null, interest?: number | null, sended?: number | null, created?: string | null, companyId?: number | null, projectId?: number | null, externalFakturaNr?: string | null, ovrigt?: string | null, fakturaAdress?: string | null, fakturaOrgNr?: string | null, typeInvoice?: number | null, typeLayout?: number | null, description?: string | null, companyName?: string | null, companyAdress?: string | null, companyAddressRow2?: string | null, companyTlfn?: string | null, companyFax?: string | null, companyMail?: string | null, companyOrgNr?: string | null, companyWebb?: string | null, companyBankGiro?: string | null, companyPostGiro?: string | null, companyIban?: string | null, companyBicSwift?: string | null, fdatum?: string | null, ffdatum?: string | null, importedFrom?: string | null, importedFromId?: number | null, payDate?: string | null, our_reference?: string | null, your_reference?: string | null, your_order_nr?: string | null, contact_id?: number | null, balance?: string | null, invoiceFee?: number | null, taxReductionWork?: string | null, taxReductionMaterial?: string | null, paymentPassed?: string | null, hasInvoiceBase_PreInvoiceTypeHyperion?: boolean | null, isLegacyTaxReductionInvoice?: boolean | null, projectsTrueIds?: string | null, contactTrueId?: string | null, contactOrderBuisnessName?: string | null, contact?: { __typename?: 'Contact', id: string, trueId?: string | null, address?: string | null, address2?: string | null, city?: string | null, cityCode?: string | null, name?: string | null, mail?: string | null, mailInvoice?: string | null, mobilePhone?: string | null, orderBuisnessName?: string | null, orgNr?: string | null, phone?: string | null } | null, invoiceSourceDocuments_PreInvoiceTypeHyperion?: { __typename?: 'invoiceSourceDocuments_PreInvoiceTypeHyperion_ModelFunctionConnection', edges?: Array<{ __typename?: 'invoiceSourceDocuments_PreInvoiceTypeHyperion_ModelFunctionEdge', node?: { __typename?: 'invoiceSourceDocuments_PreInvoiceTypeHyperion_ModelFunction', label?: string | null, url?: string | null } | null } | null> | null } | null } | null } | null> | null } | null } | null };

export type CompanyInvoiceListQueryVariables = Types.Exact<{
  last?: Types.InputMaybe<Types.Scalars['Int']>;
  first?: Types.InputMaybe<Types.Scalars['Int']>;
  offset?: Types.InputMaybe<Types.Scalars['Int']>;
  sortColumn?: Types.InputMaybe<Types.Scalars['String']>;
  status?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['Int']>> | Types.InputMaybe<Types.Scalars['Int']>>;
  statusRot?: Types.InputMaybe<Types.Scalars['Boolean']>;
  paymentPassed?: Types.InputMaybe<Types.Scalars['Boolean']>;
  kreditfaktura?: Types.InputMaybe<Types.Scalars['Boolean']>;
  typeInvoice?: Types.InputMaybe<Array<Types.InputMaybe<Types.Scalars['Int']>> | Types.InputMaybe<Types.Scalars['Int']>>;
  fakturaNr?: Types.InputMaybe<Types.Scalars['String']>;
  ocr?: Types.InputMaybe<Types.Scalars['String']>;
  contactTrueId?: Types.InputMaybe<Types.Scalars['String']>;
  contactOrderBuisnessName?: Types.InputMaybe<Types.Scalars['String']>;
  projectsTrueIds?: Types.InputMaybe<Types.Scalars['String']>;
  your_reference?: Types.InputMaybe<Types.Scalars['String']>;
  our_reference?: Types.InputMaybe<Types.Scalars['String']>;
  ovrigt?: Types.InputMaybe<Types.Scalars['String']>;
  your_order_nr?: Types.InputMaybe<Types.Scalars['String']>;
  fromFdatum?: Types.InputMaybe<Types.Scalars['String']>;
  toFdatum?: Types.InputMaybe<Types.Scalars['String']>;
  search?: Types.InputMaybe<Types.Scalars['String']>;
}>;


export type CompanyInvoiceListQuery = { __typename?: 'HyperionSchemaQuery', company?: { __typename?: 'Company', id: string, invoices?: { __typename?: 'InvoiceConnection', totalCount: number, edges?: Array<{ __typename?: 'InvoiceEdge', node?: { __typename?: 'Invoice', id: string, fakturaNr?: string | null, type?: number | null, kreditfaktura?: number | null, invoiceReminder?: number | null, sumBox?: number | null, momsBox?: string | null, rotBox?: string | null, totalBox?: string | null, bruttoBox?: number | null, status?: number | null, statusRot?: string | null, rotYear?: number | null, projectInvoiceHistory?: number | null, interest?: number | null, sended?: number | null, created?: string | null, companyId?: number | null, projectId?: number | null, externalFakturaNr?: string | null, ovrigt?: string | null, fakturaAdress?: string | null, fakturaOrgNr?: string | null, typeInvoice?: number | null, typeLayout?: number | null, description?: string | null, companyName?: string | null, companyAdress?: string | null, companyAddressRow2?: string | null, companyTlfn?: string | null, companyFax?: string | null, companyMail?: string | null, companyOrgNr?: string | null, companyWebb?: string | null, companyBankGiro?: string | null, companyPostGiro?: string | null, companyIban?: string | null, companyBicSwift?: string | null, fdatum?: string | null, ffdatum?: string | null, importedFrom?: string | null, importedFromId?: number | null, payDate?: string | null, our_reference?: string | null, your_reference?: string | null, your_order_nr?: string | null, contact_id?: number | null, balance?: string | null, invoiceFee?: number | null, taxReductionWork?: string | null, taxReductionMaterial?: string | null, paymentPassed_PreInvoiceTypeHyperion?: string | null, hasInvoiceBase_PreInvoiceTypeHyperion?: boolean | null, isLegacyTaxReductionInvoice?: boolean | null, latestCrediflowErrorMessage?: string | null, projectsTrueIds?: string | null, contactTrueId?: string | null, contactOrderBuisnessName?: string | null, contact?: { __typename?: 'Contact', id: string, trueId?: string | null, address?: string | null, address2?: string | null, city?: string | null, cityCode?: string | null, name?: string | null, mail?: string | null, mailInvoice?: string | null, mobilePhone?: string | null, orderBuisnessName?: string | null, orgNr?: string | null, phone?: string | null, parentCrediflow?: { __typename?: 'ContactCrediflowConnection', id: string, isAccepted?: number | null } | null } | null } | null } | null> | null } | null } | null };

export type RemoveInvoiceConnectionsMutationVariables = Types.Exact<{
  invoiceId?: Types.InputMaybe<Types.Scalars['Int']>;
}>;


export type RemoveInvoiceConnectionsMutation = { __typename?: 'HyperionSchemaMutation', removeInvoiceConnectionsMutation?: { __typename?: 'Invoice', id: string, mutationDetails?: Array<{ __typename?: 'ModelErrorsTypeHyperionBase', mutationSucceeded?: boolean | null, msg?: string | null } | null> | null } | null };

export const CompanySupplierInvoiceListDocument = gql`
    query companySupplierInvoiceList($last: Int, $first: Int, $offset: Int, $sortColumn: String, $status: [Int], $fakturaNr: String, $ocr: String, $contactTrueId: String, $contactOrderBuisnessName: String, $projectsTrueIds: String, $your_reference: String, $our_reference: String, $ovrigt: String, $your_order_nr: String, $fromFdatum: String, $toFdatum: String, $search: String) {
  company {
    id
    supplierInvoices(
      last: $last
      first: $first
      offset: $offset
      sort: $sortColumn
      status: $status
      fakturaNr: $fakturaNr
      ocr: $ocr
      contactTrueId: $contactTrueId
      contactOrderBuisnessName: $contactOrderBuisnessName
      projectsTrueIds: $projectsTrueIds
      your_reference: $your_reference
      our_reference: $our_reference
      ovrigt: $ovrigt
      your_order_nr: $your_order_nr
      fromFdatum: $fromFdatum
      toFdatum: $toFdatum
      search: $search
    ) {
      totalCount
      edges {
        node {
          id
          fakturaNr
          type
          kreditfaktura
          invoiceReminder
          sumBox
          momsBox
          rotBox
          totalBox
          bruttoBox
          status
          rotYear
          projectInvoiceHistory
          interest
          sended
          created
          companyId
          projectId
          externalFakturaNr
          ovrigt
          fakturaAdress
          fakturaOrgNr
          typeInvoice
          typeLayout
          description
          companyName
          companyAdress
          companyAddressRow2
          companyTlfn
          companyFax
          companyMail
          companyOrgNr
          companyWebb
          companyBankGiro
          companyPostGiro
          companyIban
          companyBicSwift
          fdatum
          ffdatum
          importedFrom
          importedFromId
          payDate
          our_reference
          your_reference
          your_order_nr
          contact_id
          balance
          invoiceFee
          taxReductionWork
          taxReductionMaterial
          paymentPassed
          hasInvoiceBase_PreInvoiceTypeHyperion
          isLegacyTaxReductionInvoice
          contact {
            id
            trueId
            address
            address2
            city
            cityCode
            name
            mail
            mailInvoice
            mobilePhone
            orderBuisnessName
            orgNr
            phone
          }
          invoiceSourceDocuments_PreInvoiceTypeHyperion {
            edges {
              node {
                label
                url
              }
            }
          }
          projectsTrueIds
          contactTrueId
          contactOrderBuisnessName
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompanySupplierInvoiceListGQL extends Apollo.Query<CompanySupplierInvoiceListQuery, CompanySupplierInvoiceListQueryVariables> {
    document = CompanySupplierInvoiceListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const CompanyInvoiceListDocument = gql`
    query companyInvoiceList($last: Int, $first: Int, $offset: Int, $sortColumn: String, $status: [Int], $statusRot: Boolean, $paymentPassed: Boolean, $kreditfaktura: Boolean, $typeInvoice: [Int], $fakturaNr: String, $ocr: String, $contactTrueId: String, $contactOrderBuisnessName: String, $projectsTrueIds: String, $your_reference: String, $our_reference: String, $ovrigt: String, $your_order_nr: String, $fromFdatum: String, $toFdatum: String, $search: String) {
  company {
    id
    invoices(
      last: $last
      first: $first
      offset: $offset
      sort: $sortColumn
      status: $status
      statusRot: $statusRot
      paymentPassed: $paymentPassed
      kreditfaktura: $kreditfaktura
      typeInvoice: $typeInvoice
      fakturaNr: $fakturaNr
      ocr: $ocr
      contactTrueId: $contactTrueId
      contactOrderBuisnessName: $contactOrderBuisnessName
      projectsTrueIds: $projectsTrueIds
      your_reference: $your_reference
      our_reference: $our_reference
      ovrigt: $ovrigt
      your_order_nr: $your_order_nr
      fromFdatum: $fromFdatum
      toFdatum: $toFdatum
      search: $search
    ) {
      totalCount
      edges {
        node {
          id
          fakturaNr
          type
          kreditfaktura
          invoiceReminder
          sumBox
          momsBox
          rotBox
          totalBox
          bruttoBox
          status
          statusRot
          rotYear
          projectInvoiceHistory
          interest
          sended
          created
          companyId
          projectId
          externalFakturaNr
          ovrigt
          fakturaAdress
          fakturaOrgNr
          typeInvoice
          typeLayout
          description
          companyName
          companyAdress
          companyAddressRow2
          companyTlfn
          companyFax
          companyMail
          companyOrgNr
          companyWebb
          companyBankGiro
          companyPostGiro
          companyIban
          companyBicSwift
          fdatum
          ffdatum
          importedFrom
          importedFromId
          payDate
          our_reference
          your_reference
          your_order_nr
          contact_id
          balance
          invoiceFee
          taxReductionWork
          taxReductionMaterial
          paymentPassed_PreInvoiceTypeHyperion
          hasInvoiceBase_PreInvoiceTypeHyperion
          isLegacyTaxReductionInvoice
          latestCrediflowErrorMessage
          contact {
            id
            trueId
            address
            address2
            city
            cityCode
            name
            mail
            mailInvoice
            mobilePhone
            orderBuisnessName
            orgNr
            phone
            parentCrediflow {
              id
              isAccepted
            }
          }
          projectsTrueIds
          contactTrueId
          contactOrderBuisnessName
        }
      }
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class CompanyInvoiceListGQL extends Apollo.Query<CompanyInvoiceListQuery, CompanyInvoiceListQueryVariables> {
    document = CompanyInvoiceListDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }
export const RemoveInvoiceConnectionsDocument = gql`
    mutation removeInvoiceConnections($invoiceId: Int) {
  removeInvoiceConnectionsMutation(invoiceId: $invoiceId) {
    id
    mutationDetails {
      mutationSucceeded
      msg
    }
  }
}
    `;

  @Injectable({
    providedIn: 'root'
  })
  export class RemoveInvoiceConnectionsGQL extends Apollo.Mutation<RemoveInvoiceConnectionsMutation, RemoveInvoiceConnectionsMutationVariables> {
    document = RemoveInvoiceConnectionsDocument;
    
    constructor(apollo: Apollo.Apollo) {
      super(apollo);
    }
  }